import { CropSquareImage } from './CropSquareImage'
import { withCropSquareImage } from './withCropSquareImage'

const ConnectedCropSquareImage = withCropSquareImage(CropSquareImage)

export { ConnectedCropSquareImage as CropSquareImage }
